import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  styled,
  Avatar,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useFetchEmployeeProfileMutation } from "../../services/profileService";
import useAuth from "../../hooks/useAuth";
import HistoryIcon from "@mui/icons-material/History";
import DescriptionIcon from "@mui/icons-material/Description";
import { useFetchReportHistoryQuery } from "../../services/user-reportService";
import Person2Icon from "@mui/icons-material/Person2";
import RedoIcon from "@mui/icons-material/Redo";
import { DataGrid } from "@mui/x-data-grid";

const Dashboard = () => {
  const { users } = useAuth();
  console.log(users?.user_id);

  const navigate = useNavigate();

  const employeeId = users?.user_id;
  console.log(employeeId);

  // const [anchorProfile, setAnchorProfile] = useState(null);
  // const [anchorNotification, setAnchorNotification] = useState(null);

  const [profileCompletion, setProfileCompletion] = useState(50); // Default completion
  const [profileData, setProfileData] = useState({});
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);

  const [fetchEmployeeProfile] = useFetchEmployeeProfileMutation();
  // const [reportHistory, setReportHistory] = useState([]);
  // const [emailHistory, setEmailHistory] = useState([]);

  // const openProfileMenu = Boolean(anchorProfile);
  // const openNotificationMenu = Boolean(anchorNotification);
  const [openHistory, setOpenHistory] = useState(false);
  const [openEmailHistory, setOpenEmailHistory] = useState(false);

  const {
    data: reportReportHistories,
    refetch: reportHisotory,
  } = useFetchReportHistoryQuery(employeeId);
  console.log("reportReportHistories", reportReportHistories);
  console.log(profileData);
  
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetchEmployeeProfile(employeeId).unwrap();
        setProfileData(response.data);
        // fetchHistoryData();
        calculateCompletion(response.data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    if (employeeId) {
      fetchProfile();
    }
  }, [employeeId, fetchEmployeeProfile]);

  const handleCloseHistory = () => {
    setOpenHistory(false);
  };

  const handleCloseEmailHistory = () => {
    setOpenEmailHistory(false);
  };

  const reportReportHistoriesArray = Array.isArray(
    reportReportHistories?.data?.report_history
  )
    ? reportReportHistories?.data?.report_history
    : [];

  const emailHistoryArray = Array.isArray(
    reportReportHistories?.data?.email_history
  )
    ? reportReportHistories?.data.email_history
    : [];
  console.log(reportReportHistoriesArray);
  console.log(emailHistoryArray);

  // console.log(reportReportHistoriesArray.data.data.report_history)

  const handleHistoryClick = () => {
    setOpenHistory(true);
    console.log(users?.user_id);
    reportHisotory();

    // Fetch data when opening
  };
  const handleEmailHistoryClick = () => {
    setOpenEmailHistory(true);
    console.log(users?.user_id);
    // reportHisotory()
    reportHisotory();

    // Fetch data when opening
  };
  const calculateCompletion = (data) => {
    let completedFields = 0;
    const totalFields = 4; // Adjust to the number of fields you're checking

    if (data?.job_title) completedFields++;
    if (data?.manager_id) completedFields++;
    // if (data?.organization_id) completedFields++;
    if (data?.company_name) completedFields++;
    if (data?.purpose) completedFields++;
    
    // Example additional field
    // Example additional field

    const percentage = Math.round((completedFields / totalFields) * 100);
    setProfileCompletion(percentage);
    setIsProfileCompleted(percentage === 100);
  };
  console.log(reportReportHistoriesArray.length);

  const columnsReport = [
    {
      field: "version_number",
      headerName: "Version Number",
      width: 200,
    },
    {
      field: "body",
      headerName: "Content",
      flex: 1,
      minWidth: 300,
      renderCell: (params) => {
        const content = params.row.content;
        if (!content || Object.keys(content).length === 0) {
          return <Typography variant="body2">No content available</Typography>;
        }
        return (
          <>
            <Typography variant="body2">
              <Box component="span" sx={{ fontWeight: "700" }}>
                Name:
              </Box>{" "}
              {content?.role_review?.name || "N/A"}
            </Typography>

            <Typography variant="body2">
              <Box component="span" sx={{ fontWeight: "700" }}>
                Title:
              </Box>{" "}
              {content?.role_review?.title || "N/A"}
            </Typography>
            <Typography variant="body2">
              <Box component="span" sx={{ fontWeight: "700" }}>
                Job Summary:
              </Box>{" "}
              {content?.role_review?.job_summary || "N/A"}
            </Typography>

            <Typography variant="body2">
              <Box component="span" sx={{ fontWeight: "700" }}>
                Job Summary:
              </Box>{" "}
              {content?.role_review?.job_summary || "N/A"}
            </Typography>
            {/* Core Focus Areas Section */}
            <Typography variant="body2">
              <Box sx={{ fontWeight: "700" }}>Core Focus Areas:</Box>
            </Typography>
            {content?.core_focus_areas?.map((area, idx) => (
              <Box key={idx} sx={{ marginLeft: "15px" }}>
                <Typography variant="body2">
                  <Box component="span" sx={{ fontWeight: "700" }}>
                    Area:
                  </Box>{" "}
                  {area.area || "N/A"}
                </Typography>
                <Typography variant="body2">
                  <Box component="span" sx={{ fontWeight: "700" }}>
                    Importance:
                  </Box>{" "}
                  {area.importance || "N/A"}
                </Typography>
                <Typography variant="body2">
                  <Box component="span" sx={{ fontWeight: "700" }}>
                    Time Spent:
                  </Box>{" "}
                  {area.time_spent || "N/A"}
                </Typography>

                {area.critical_activities &&
                  area.critical_activities.length > 0 && (
                    <>
                      <Typography variant="body2" sx={{ marginLeft: "0" }}>
                        <Box component="span" sx={{ fontWeight: "700" }}>
                          Critical Activities:
                        </Box>
                      </Typography>
                      {area.critical_activities.map((activity, activityIdx) => (
                        <Box key={activityIdx} sx={{ marginLeft: "15px" }}>
                          <Typography variant="body2">
                            <Box component="span" sx={{ fontWeight: "700" }}>
                              Activity Area:
                            </Box>{" "}
                            {activity.area || "N/A"}
                          </Typography>
                          <Typography variant="body2">
                            <Box component="span" sx={{ fontWeight: "700" }}>
                              Activity Importance:
                            </Box>{" "}
                            {activity.importance || "N/A"}
                          </Typography>
                        </Box>
                      ))}
                    </>
                  )}
              </Box>
            ))}
          </>
        );
      },
    },
  ];
  const columnsEmail = [
    {
      field: "subject",
      headerName: "Subject",
      width: 180,
    },
    {
      field: "body",
      headerName: "Body",
      flex: 2,
      minWidth: 350,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
      minWidth: 100,
      renderCell: (params) => {
        let chipColor;
        if (params.value === "failed") {
          chipColor = "error";
        } else if (params.value === "pending") {
          chipColor = "warning";
        } else if (params.value === "sent") {
          chipColor = "success";
        }
        return <Chip label={params.value} color={chipColor} size="small" />;
      },
    },
    {
      field: "sent_at",
      headerName: "Sent At",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const date = new Date(params.row.sent_at);
        return date.toLocaleString();
      },
    },
  ];

  const emailHistoryWithId = emailHistoryArray.map((item, index) => ({
    ...item,
    id: item.emailId || index,
  }));

  const reportHistoryWithId = reportReportHistoriesArray.map((item, index) => ({
    ...item,
    id: item.emailId || index,
  }));

  return (
    <>
      <SectionWrap component="section">
        <ContainerWrap>
          <RowWrap>
            {/* Profile Completion */}
            <Col6Wrap>
              <DashboardBoxWrap>
                {isProfileCompleted ? (
                  <>
                    <Avatar
                      sx={{
                        bgcolor: "#2e7d32",
                        margin: "0 auto 10px",
                        width: "60px",
                        height: "60px",
                      }}
                    >
                      <Person2Icon sx={{ fontSize: "40px" }} />
                    </Avatar>
                    <TitleWrap sx={{ color: "#2e7d32" }}>
                      {profileCompletion}%
                    </TitleWrap>
                  </>
                ) : (
                  <>
                    <Avatar
                      sx={{
                        bgcolor: "#d32f2f",
                        margin: "0 auto 10px",
                        width: "60px",
                        height: "60px",
                      }}
                    >
                      <Person2Icon sx={{ fontSize: "40px" }} />
                    </Avatar>
                    <TitleWrap sx={{ color: "#d32f2f" }}>
                      {profileCompletion}%
                    </TitleWrap>
                  </>
                )}

                <TitleWrap>Profile Completion</TitleWrap>
                {isProfileCompleted ? (
                  <ContentWrap>
                    Your profile is 100% complete! Great job!
                  </ContentWrap>
                ) : (
                  <ContentWrap>
                    Complete your profile to unlock more features.
                  </ContentWrap>
                )}
                <CustomBtn
                  type="submit"
                  variant="outlined"
                  onClick={() => navigate("/employee/profile/basic-info")}
                >
                  Update Profile
                </CustomBtn>
              </DashboardBoxWrap>
            </Col6Wrap>
            {/* Reports */}
            <Col6Wrap>
              <DashboardBoxWrap>
                <Avatar
                  sx={{
                    bgcolor: "#F28021",
                    margin: "0 auto 20px",
                    width: "60px",
                    height: "60px",
                  }}
                >
                  <DescriptionIcon sx={{ fontSize: "40px" }} />
                </Avatar>
                <TitleWrap>Reports</TitleWrap>
                <ContentWrap>
                  View reports generated by you. Click the button to access your
                  reports.
                </ContentWrap>
                <CustomBtn
                  type="submit"
                  variant="outlined"
                  onClick={() => navigate("/user-reports")}
                >
                  View Reports
                </CustomBtn>
              </DashboardBoxWrap>
            </Col6Wrap>
            {/* Next Steps */}
            <Col6Wrap>
              <DashboardBoxWrap>
                <Avatar
                  sx={{
                    bgcolor: "#F28021",
                    margin: "0 auto 20px",
                    width: "60px",
                    height: "60px",
                  }}
                >
                  <RedoIcon sx={{ fontSize: "40px" }} />
                </Avatar>
                <TitleWrap>Next Steps</TitleWrap>
                <ContentWrap>
                  Complete your profile to 100% by filling in all required
                  details. Once your profile is complete, you will unlock
                  additional features.
                </ContentWrap>
                {isProfileCompleted && (
                  <CustomBtn
                    type="submit"
                    variant="outlined"
                    onClick={() => navigate("/user_details-steps")}
                  >
                    Add User Info
                  </CustomBtn>
                )}
              </DashboardBoxWrap>
            </Col6Wrap>
            {/* History Logs */}
            <Col6Wrap>
              <DashboardBoxWrap>
                <Avatar
                  sx={{
                    bgcolor: "#F28021",
                    margin: "0 auto 20px",
                    width: "60px",
                    height: "60px",
                  }}
                >
                  <HistoryIcon sx={{ fontSize: "40px" }} />
                </Avatar>
                <TitleWrap>History Logs</TitleWrap>
                <ContentWrap>
                  View History logs generated by you. Click the button to access
                  your history.
                </ContentWrap>
                <Box
                  sx={{
                    display: "flex",
                    columnGap: "10px",
                    justifyContent: "center",
                  }}
                >
                  <CustomBtn
                    variant="outlined"
                    onClick={handleHistoryClick}
                    aria-controls={openHistory ? "history-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openHistory ? "true" : undefined}
                  >
                    Report Versions
                  </CustomBtn>
                  <CustomBtn
                    variant="outlined"
                    onClick={handleEmailHistoryClick}
                    aria-controls={
                      openEmailHistory ? "history-menu" : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={openEmailHistory ? "true" : undefined}
                  >
                    Email History
                  </CustomBtn>
                </Box>
                {/* Report Versions */}
                <Dialog
                  open={openHistory}
                  onClose={handleCloseHistory}
                  fullWidth
                  maxWidth="lg"
                  sx={{
                    "& .MuiDialog-paper": {
                      padding: "30px",
                    },
                  }}
                >
                  <DialogTitleWrap>Report Versions</DialogTitleWrap>
                  <DataGrid
                    sx={{ "& .MuiDataGrid-cell": { padding: "20px 10px" } }}
                    rows={reportHistoryWithId}
                    columns={columnsReport}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 30,
                        },
                      },
                    }}
                    pageSizeOptions={[30]}
                    disableRowSelectionOnClick
                    disableColumnMenu={true}
                    getRowHeight={() => "auto"}
                  />
                </Dialog>
                {/* Email History */}
                <Dialog
                  open={openEmailHistory}
                  onClose={handleCloseEmailHistory}
                  fullWidth
                  maxWidth="lg"
                  sx={{
                    "& .MuiDialog-paper": {
                      padding: "30px",
                    },
                  }}
                >
                  <DialogTitleWrap>Email History</DialogTitleWrap>
                  <DataGrid
                    rows={emailHistoryWithId}
                    columns={columnsEmail}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 30,
                        },
                      },
                    }}
                    pageSizeOptions={[30]}
                    disableRowSelectionOnClick
                    disableColumnMenu={true}
                  />
                </Dialog>
              </DashboardBoxWrap>
            </Col6Wrap>
          </RowWrap>
        </ContainerWrap>
      </SectionWrap>
    </>
  );
};

export default Dashboard;


const SectionWrap = styled(Box)(() => ({
  padding: "50px 0",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1170px",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col6Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "50%",
  paddingLeft: "15px",
  paddingRight: "15px",
  "@media (max-width: 767px)": {
    maxWidth: "100%",
  },
}));
const DashboardBoxWrap = styled(Box)(() => ({
  padding: "50px 50px",
  background: "#ffffff",
  borderRadius: "7px",
  textAlign: "center",
  marginBottom: "30px",
  height: "calc(100% - 30px)",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 991px)": {
    padding: "30px 30px",
  },
}));
const TitleWrap = styled(Typography)(() => ({
  fontSize: "20px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#000000",
  marginBottom: "15px",
}));
const ContentWrap = styled(Typography)(() => ({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1.445",
  color: "#7C7C7C",
  marginBottom: "25px",
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  padding: "13px 10px",
  maxWidth: "200px",
  boxShadow: "none !important",
}));
const DialogTitleWrap = styled(DialogTitle)(() => ({
  fontSize: "20px",
  fontWeight: "600",
  lineHeight: "1.445",
  color: "#000000",
  marginBottom: "15px",
  padding: "0",
}));




